import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as moment from 'moment';

import { NewPurchaseReturnModel } from '../../../model/index';
import { NewPurchaseReturnService, SubscribeService } from '../../../services/index';

@Component({
    selector: 'newPurchaseReturn-tab',
    templateUrl: './newPurchaseReturn.component.html',
})

export class NewPurchaseReturnComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public purchaseReturnData: any[] = [];

    isLoadMask: Promise<any>;
    purchaseReturnEntryData: NewPurchaseReturnModel[];
    isLoading: boolean = false;

    constructor(private newPurchaseReturnService: NewPurchaseReturnService,
        public subscribeService: SubscribeService,
        private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    filterExpand: boolean = false;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'return_id',
        orderDir: 'desc'
    };
    filterData = {
        "search_name": "",
        "from_date": new Date(),
        "to_date": new Date()
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('cnReplacementTemplate') cnReplacementTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    columns = [];
    toggleCol = [];

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Return No', prop: 'auto_no', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Return Date', prop: 'disp_date', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Party Name', prop: 'party_name', width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'Branch', prop: 'company_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Description', prop: 'description', width: 180, minWidth: 180, maxWidth: 180 },
            { name: 'Total Quantity', prop: 'quantity', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Total Amount', prop: 'grand_total', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'CN / Replacement', prop: 'credit_note', width: 240, minWidth: 240, maxWidth: 240, sortable: false, cellClass: 'cell-center', cellTemplate: this.cnReplacementTemplate },
            { name: 'Action', prop: 'sno', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);

        this.pageCallback({ offset: 0 });
        //THIS WILL WORK WHEN BILL SAVED IN OTHER TAB
        this.subscribeService.publishReloadNewPurchaseReturnListGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getNewPurchaseReturnList();
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getNewPurchaseReturnList();
    }
    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }
    onOpenedFilter(): void {
        setTimeout(function () {
            $('#filterSearch').focus();
        }, 100);

    }
    clearFilter(): void {
        this.filterData = {
            "search_name": "",
            "from_date": new Date(),
            "to_date": new Date()
        };
        this.applyFilter();
    }
    applyFilter(): void {
        this.filterPanel.close();
        this.getNewPurchaseReturnList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getNewPurchaseReturnList();
    }
    getNewPurchaseReturnList(): void {
        let that = this,
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderDir: `${this.page.orderDir}`,
                search_name: this.filterData['search_name'],
                from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
                to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
                from_page: this['params']['tabParams'],
                mode: this['params']['mode']
            };

        this.isLoadMask = this.newPurchaseReturnService
            .getNewPurchaseReturnList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.purchaseReturnData = res.data;
            });
    }


    addNewPurchaseReturn(mode: string, row: any): void {
        let that = this;
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'return_id': '',
                'mode': mode
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
        } else if (mode == "View") {
            row['mode'] = mode;
        }

        let tabParams = (that.dataContext && that.dataContext.tabParams) ? that.dataContext.tabParams : 'Purchase Return';
        that.subscribeService.subScribeTabID('Transaction', 'AddEditNewPurchaseReturnComponent', row, tabParams);
    }

    openReplacement(row: any): void {
        let params = {
            mode: 'Add',
            purchase_return_id: row.return_id,
            party_id: row.party_id,
            party_name: row.party_name
        };
        this.subscribeService.subScribeTabID('Transaction', 'AddEditPurchaseInvoiceComponent', params, 'Purchase Invoice');
    }

    updateCreditNote(row: any): void {
        let that = this;
        let newValue = (row.credit_note === 'Yes') ? 'No' : 'Yes';
        swal({
            title: 'Credit Note',
            text: 'Mark Credit Note as ' + newValue + ' for Return No: ' + row.auto_no + '?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result) {
                let params = {
                    return_id: row.return_id,
                    credit_note: newValue
                };
                that.newPurchaseReturnService.updateCreditNote(params).then(function (res: any) {
                    if (res.success) {
                        row.credit_note = newValue;
                        that.purchaseReturnData = [...that.purchaseReturnData];
                        swal('Updated!', 'Credit Note marked as ' + newValue, 'success');
                    } else {
                        swal('Error!', res.message, 'error');
                    }
                });
            }
        });
    }

    deleteNewPurchaseReturn(row: any): void {
        console.log('Delete function called with row:', row);
        let that = this;
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this Purchase Return data!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            console.log('SweetAlert result:', result);
            if (result) {
                let params = {
                    'return_id': row['return_id'],
                    'mode': 'Delete'
                };
                console.log('Calling delete service with params:', params);
                that.newPurchaseReturnService.deleteNewPurchaseReturnEntry(params).then(function (res: any) {
                    console.log('Delete service response:', res);
                    if (res.success) {
                        swal(
                            'Deleted!',
                            res.message,
                            'success'
                        ).then(() => {
                            that.pageCallback({ offset: 0 });
                        });

                    } else {
                        swal(
                            'Error!',
                            res.message,
                            'error'
                        );
                    }
                }).catch(function (error) {
                    console.error('Delete service error:', error);
                    swal(
                        'Error!',
                        'Failed to delete: ' + error.message,
                        'error'
                    );
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/newPurchaseReturn/newPurchaseReturn.component.ts